<template>
  <div class="bg-primary rounded-lg w-fit p-1">
    <icon :icon="AwardSvg" class="text-on-primary" />
  </div>
</template>
<script setup lang="ts">
import { Icon } from '~/components/icon';
import AwardSvg from '~/assets/icons/award.svg?component';
</script>
